import { registryPageData as registryCatalogPageData } from '@data-ts/pages/registry';
export const registryPageData = {
  seoText: 'Landing page dedicated to Joy’s honeymoon and experiences registries | Joy',
  title: 'And remember,<br/>we’re always here for you.',
  content: 'Chat with the best customer service team in weddings —<br/>we’re here to make sure you get to the big day without the fray.',
  quote: 'I get paid to help people in love — it doesn’t get better than that!',
  caption: 'Jane Doe, Team Member since 2015',
  seo: {
    title: 'Honeymoon Fund Registry with Zero Fees - Joy',
    content:
      'Create your honeymoon fund registry with cash gifts, plane tickets, hotel stays, experiences, luggage and other essential items for your honeymoon.',
  },
  getStarted: 'Get Started',
  hero: {
    eyebrow: 'The All-in-One Wedding Registry',
    title: 'Honeymoon funds with zero-fees.',
    content:
      'Your dream registry lets you add items from any store and connect all your registries in one place. Have it all, from gifts and experiences, to cash funds and charities.',
    findAnEvent: 'Find an Event',
    bullet1: 'Save for your honeymoon faster ',
    bullet2: 'Register for experiences',
    bullet3: 'Add gifts, cash funds, and more to one registry',
  },
  noFeeCashEverWrapper: {
    title: 'No fees on cash. Yes, really.',
    body: 'We don’t take a dime, so you and your guests don’t pay a dime on cash gifts and honeymoon funds.',
    fee2BlogText: 'No fees on cash, ever.',
  },
  registryDreamStartHereSection: {
    title: 'Your dream honeymoon starts here.',
    eyebrow: 'Honeymoon Funds',
    body:
      'Whether you’re requesting airfare, a hotel stay, or honeymoon travel experiences, create one list for all your honeymoon wishes. Choose from hundreds of cash fund options to customize, or create your own to perfectly fit your honeymoon plans.',
    slides: [
      {
        bgColor: '#E0F9FF',
        bgImage: 'honeymoon-fund/fund1-v2.jpg',
        bgImageMobile: 'honeymoon-fund/mobile-fund1.jpg',
        eyebrowColor: 'humanaDark4',
        titleColor: 'neutra6',
        bodyColor: 'neutra6',
      },
      {
        bgColor: '#FCF4EE',
        bgImage: 'honeymoon-fund/fund2-v2.jpg',
        bgImageMobile: 'honeymoon-fund/mobile-fund2.jpg',
        eyebrowColor: 'humanaDark4',
        titleColor: 'neutra6',
        bodyColor: 'neutra6',
      },
      {
        bgColor: '#f8f8f8',
        bgImage: 'honeymoon-fund/fund3-v2.jpg',
        bgImageMobile: 'honeymoon-fund/mobile-fund3.jpg',
        eyebrowColor: 'humanaDark4',
        titleColor: 'neutra6',
        bodyColor: 'neutra6',
      },
      {
        bgColor: '#201f24',
        bgImage: 'honeymoon-fund/fund4-v2.jpg',
        bgImageMobile: 'honeymoon-fund/mobile-fund4.jpg',
        eyebrowColor: 'humanaDark4',
        titleColor: 'white',
        bodyColor: 'white',
      },
    ],
  },
  chooseExperiencesSection: {
    eyebrow: 'Honeymoon Experiences',
    title: 'Choose from thousands of experiences.',
    feature:
      'From adventure to romance, culinary to relaxation, register for incredible experiences in top honeymoon destinations, right from the Joy Shop.',
    getExploreExperiences: 'Explore Experiences',
  },
  publicCatalogSection: {
    eyebrow: 'The Joy Shop',
    title: 'Register for your honeymoon must-haves.',
    feature: 'Explore everything you need for your honeymoon, plus top-rated gift registry essentials, to complete your wish list.',
    body: 'Shop by Department',
    departmentIconList: registryCatalogPageData.publicCatalogSection.departmentIconList,
    catlogList: [
      {
        image: 'honeymoon-fund/product-luggage-v2.jpg',
        title: 'Away',
        body: 'The Bigger Carry-On',
        url: 'https://withjoy.com/shop/item/f3598c55-d1f2-5e9a-99a0-f5ec4aee4bad',
      },
      {
        image: 'honeymoon-fund/product-airbnb.jpg',
        title: 'Airbnb',
        body: 'Airbnb Gift Card',
        url: 'https://withjoy.com/shop/item/36e71fb5-0ce2-5539-87a2-b14a16335c9f',
      },
      {
        image: 'honeymoon-fund/product-knives-v2.jpg',
        title: 'GSI Outdoors',
        body: 'Santoku Knife Set',
        url: 'https://withjoy.com/shop/item/f97e58d8-ddc5-5c12-a349-fba8aa438f79',
      },
      {
        image: 'honeymoon-fund/product-hammock-v2.jpg',
        title: 'ENO',
        body: 'DoubleNest Hammock',
        url: 'https://withjoy.com/shop/item/4f92b20a-a267-5d26-8db6-26668b855e71',
      },
      {
        image: 'honeymoon-fund/product-pillow-v2.jpg',
        title: 'Genuine Picks',
        body: 'Luxury Memory Foam Neck Travel Pillow',
        url: 'https://withjoy.com/shop/item/0d750f91-6c79-5334-86c0-dcdd7f18f636',
      },
      {
        image: 'honeymoon-fund/product-yeti-v2.jpg',
        title: 'YETI',
        body: 'Lowlands Blanket',
        url: 'https://withjoy.com/shop/item/a5bda8df-509b-5793-b546-0b0be0c367d5',
      },
    ],
    exploreShopButton: {
      label: 'Explore the Shop',
      url: 'https://withjoy.com/shop',
    },
  },
  linkedRegistrySection: {
    eyebrow: 'We Love All Registries',
    title: 'Sync and link any registry.',
    body: 'Already registered? No problem. Connect any registry and allow your guests to shop in one easy place.',
  },
  charityRegistrySection: {
    eyebrow: 'Charity Donations',
    title: 'Gifts that</br>keep on giving.',
    body: 'Support your favorite causes, right from your wedding registry.',
  },
  oneRegistrySection: {
    eyebrow: 'One Link For All Your Guests',
    title: 'Better for your guests means better for you.',
    body: 'Make it easy for your guests to give you the perfect gift, with everything you want right on your wedding website.',
  },
  registryApp: {
    eyebrow: 'Shop on Your Phone',
    title: 'Add items from wherever, whenever.',
    body: 'Shop from any store, manage your registry, even track who has purchased what, right on your phone.',
    download: 'Download',
    joy: 'Joy for iOS or Android',
    altTextAppStore: 'app store',
    altTextGooglePlay: 'google play',
  },
  registryBrandsSection: {
    eyebrow: 'Shop ‘Til You Drop',
    title: 'Your favorite brands, together at last.',
    body: 'Ask for exactly what you want — from flatware to gift cards — all in one place.',
  },
  registryCrossSection: {
    eyebrow: 'The Best Part',
    title: 'Your wedding registry comes with Joy.',
    body:
      'From a beautiful wedding website and matching invites, to powerful wedding planning tools and our always-here-for-you customer support team, we’ve built the smarter way to plan your big day.',
    featuresData: [
      {
        image: 'honeymoon-fund/icon-website-v2.svg',
        title: 'Free Wedding</br>Websites',
      },
      {
        image: 'honeymoon-fund/icon-cards-v2.svg',
        title: 'Save the Dates, Invites & Matching Prints',
      },
      {
        image: 'honeymoon-fund/icon-wand-v2.svg',
        title: 'Powerful</br>Planning Tools',
      },
      {
        image: 'honeymoon-fund/icon-support-v2.svg',
        title: 'Personal</br>Customer Support',
      },
    ],
  },
  registryJoyButtonSection: {
    eyebrow: 'The Joy Browser Button',
    title: 'Add gifts from any website, literally.',
    body:
      'Shop anywhere with the Joy Browser Button. Add items from top brands, your favorite Etsy store, or the little shop around the corner, with a click of a button.',
  },
  universalRegistrySection: {
    eyeBrow: 'Your Universal Registry',
    title: 'Ask for everything you want, in one place.',
    content:
      'Add honeymoon and cash funds, experiences, gifts, and more to your All-in-One Registry, giving your wedding guests one convenient place to shop.',
    madeItEasier: 'We’ve made it better to give <em>and</em> receive.',
    registryItemImageAlt: 'Registry item',
    registryTypeGifts: 'Gifts',
    registryTypeCash: 'Cash Funds',
    registryTypeExperiences: 'Experiences',
    registryTypeCharity: 'Charity',
  },
  emotionalBreak: {
    title: 'Designed to let you focus on what matters.',
    altText: 'Image of couple dancing in an aquarium',
  },
  sections: {
    faqList: {
      title: 'Still have questions?',
    },
    stats: {
      title: 'We’ve helped millions celebrate love around the world.',
      subtitle: 'That’s more cake, flowers and happy tears than we can count.',
      data: [
        {
          title: 'million',
          body: 'The largest guest list in Joy',
          endingNumber: 8,
          incrementFrequency: 150,
        },
        {
          title: 'countries',
          body: 'Screaming babies have interrupted weddings on',
          endingNumber: 86,
          incrementFrequency: 100,
        },
        {
          title: 'guests',
          body: 'People around the world',
          endingNumber: 768,
          incrementFrequency: 20,
        },
      ],
    },
  },
} as const;
